
export const readonlyQuillProps = {
  modules: {
    toolbar: false
  },
  readOnly: true
};
